import React, { useState } from "react";
import { Button } from "react-bootstrap";


const RekognitionButton = (props) => {
  const [started, setStarted] = useState(false);

  return (
    <Button
      className="rekognition-button"
      onClick={(e) => {
        setStarted(!started);
        props.onClick(e);
      }}
      disabled={!props.enabled}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '200px',
        height: '80px',
        margin: '400px auto',
        position: 'relative',
 //bottom: '100px',
        backgroundColor: '#5646ff',
        borderRadius: '40px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
        border: 'none',
        padding: '0px',
        textAlign: 'center',
        cursor: 'pointer',
        transition: 'box-shadow 0.3s ease',
      }}
      onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.2)'}
      onMouseOut={(e) => e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)'}
    >
      {/* <img src="/tarjeta.png" style={{ height: '40px', marginBottom:'20px' }} /> */}
      <span style={{ color: '#ffffff',
        fontFamily: 'Arial, sans-serif', fontSize: '35px', fontWeight: 'bold' }}>{started ? "" : "haz clic"}</span>
    </Button>
  );
};

export default RekognitionButton;
